"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendTemplate = void 0;
const TemplateUtils_1 = require("./TemplateUtils");
class ExtendTemplate {
    static resolve(f) {
        if (f.args) {
            const extendedTypes = f.args
                .filter((e) => (e.args && e.args.length) || (e.directives && e.directives.length) || (e.interfaces && e.interfaces.length))
                .map((e) => TemplateUtils_1.TemplateUtils.resolverForConnection(Object.assign(Object.assign({}, e), { type: Object.assign(Object.assign({}, e.type), { name: e.data.type }) })))
                .join('\n');
            return extendedTypes;
        }
        return '';
    }
}
exports.ExtendTemplate = ExtendTemplate;
